// App.tsx
import React from "react";
import "./styles/global.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        … <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
